module.exports = __webpack_public_path__ + "img/Email-Reset-Password512.91245ad6.png";